"use strict";

// NPM INCLUDES

var numeral = require('numeral'); // http://numeraljs.com/
var converter = require('number-to-words');
var titleCase = require('title-case').titleCase;
var moment = require('moment-timezone');

// A glue file for importing formatting and calculation tools

// #######
// IMPORTS
// #######

var bizDays = require("./lib/bizDays.js");
var coerceDate = require("./lib/coerceDate.js");
var coerceFloat = require("./lib/coerceFloat.js");
var coerceBoolean = require("./lib/coerceBoolean.js");
var periodicRate = require("./lib/periodicRate.js");
var nextBizDay = require("./lib/nextBizDay.js");
var prevBizDay = require("./lib/prevBizDay.js");
var coerceDatetime = require("./lib/coerceDatetime.js");

exports.bizDays = bizDays;
exports.nextBizDay = nextBizDay;
exports.coerceDate = coerceDate;
exports.coerceFloat = coerceFloat;
exports.coerceBoolean = coerceBoolean;
exports.periodicRate = periodicRate;
exports.prevBizDay = prevBizDay;
exports.coerceDatetime = coerceDatetime;

// ###########
// DEFINITIONS
// ###########

exports.bigUSD = n => {
	var x = coerceFloat(n);
	return numeral(x).format('$0,0');
}

exports.bigUSDzero = n => {

	if (n === null) return '';
	if (n === undefined) return '';
	if (n === '') return '';

	var x = coerceFloat(n);
	if (x === 0) return '$0';

	return numeral(x).format('$0,0');
}

exports.zeroDec = n => {
	var x = coerceFloat(n);
	return numeral(x).format('0,0');
}

exports.oneDec = n => {
	var x = coerceFloat(n);
	return numeral(x).format('0,0.0');
}

exports.oneDecZero = n => {
	var x = coerceFloat(n);
	if ((x < 0.01) && (x > -0.01)) return '0';
	return numeral(x).format('0,0.0');
}

exports.twoDecZero = n => {
	var x = coerceFloat(n);
	if ((x < 0.001) && (x > -0.001)) return '0';
	return numeral(x).format('0.00');
}

exports.twoDec = n => {
	var x = coerceFloat(n);
	return numeral(x).format('0,0.00');
}

exports.twoDecNoComma = n => {
	var x = coerceFloat(n);
	return numeral(x).format('0.00');
}

exports.threeDec = n => {
	var x = coerceFloat(n);
	return numeral(x).format('0,0.000');
}

exports.fourDec = n => {
	var x = coerceFloat(n);
	return numeral(x).format('0,0.0000');
}

exports.smallUSD = n => {
	var x = coerceFloat(n);
	if ((x < 0.01) && (x > -0.01)) return '$0.00';
	return numeral(x).format('$0,0.00');
}

exports.smallUSDBlank = n => {
	var x = coerceFloat(n);
	if ((x < 0.01) && (x > -0.01)) return '';
	return numeral(x).format('$0,0.00');
}

exports.smallUSDZero = n => {
	var x = coerceFloat(n);
	if ((x < 0.01) && (x > -0.01)) return '$0.00';
	return numeral(x).format('$0,0.00');
}

exports.decimalToPercent = n => {
	var x = coerceFloat(n) * 100;
	var formatted = numeral(x).format('0.00') + '%';
	return formatted;
}

exports.decimalToPercentZero = n => {
	if (n === null) return '';
	if (n === undefined) return '';
	if (n === '') return '';

	var x = coerceFloat(n) * 100;
	if (x === 0) return '0%';
	var formatted = numeral(x).format('0.00') + '%';
	return formatted;
}

exports.percentage = n => {
	var x = coerceFloat(n);
	var formatted = numeral(x).format('0.00') + '%';
	return formatted;
}

exports.percentageZero = n => {
	if (n === null) return '0';
	if (n === undefined) return '0';
	if (n === '') return '0';

	var x = coerceFloat(n);
	if (x === 0.0) return '0';

	var formatted = numeral(x).format('0.00') + '%';
	return formatted;
}

exports.percentageNoDecZero = n => {
	if (n === null) return '0';
	if (n === undefined) return '0';
	if (n === '') return '0';

	var x = Math.round(coerceFloat(n));

	var formatted = numeral(x).format('0') + '%';
	return formatted;
}

exports.percentOneDec = n => {
	if (! n) return '';
	var x = coerceFloat(n);
	return numeral(x).format('0.0%');
}

exports.percentThreeDec = n => {
	if (! n) return '';
	var x = coerceFloat(n);
	return numeral(x).format('0.000');
}

exports.percentageThreeDec = n => {
	if (!n) return '';
	var x = coerceFloat(n);
	var formatted = numeral(x).format('0.000') + '%';
	return formatted;
}

exports.percentAdaptive = n => {
	if (! n) return '';
	var x = coerceFloat(n);
	if (x < 0.01) return numeral(x).format('.00%');
	if (x < 0.1) return numeral(x).format('0.0%');
	return numeral(x).format('0%');
}

exports.percentAdaptiveTwo = n => {
	if (! n) return '';
	var x = coerceFloat(n);
	if (x < 0.01) return numeral(x).format('.00%');
	if (x < 0.1) return numeral(x).format('0.00%');
	return numeral(x).format('0.00%');
}

// only used in old editLoans_dev-backup.js. I dont think we need this anymore.
exports.trueFalse = f => {
	if (! f) return 'False';
	return 'True';
}

exports.yesNo = f => {
	if (! f) return 'No';
	return 'Yes';
}

exports.yN = f => {
	if (! f) return 'N';
	return 'Y';
}

exports.enabledDisabled = f => {
	if (! f) return 'Disabled';
	return 'Enabled';
}
exports.yesBlank = f => {
	if (f) return 'Yes';
	return '';
}

exports.clearWaiv = f => {
	if (! f) return 'Not Cleared';
	else if (f) return f;
}

exports.shortDate = d => {
	if (! d) return '';
	var x = coerceDate(d);
	if (! x) return '';
	var m = moment(x);
	return m.format("MM/DD/YYYY");
}


exports.logDate = d => {
	if (! d) return '';
	var x = coerceDate(d);
	if (! x) return '';
	var m = moment(x);
	return m.format("YYYY-MM-DD HH:mm:ss");
}

// TODO: it seems like we could get away with making all of the existing FMT functions operate in mountain time,
// but I'm afraid to change functions that are used in so many places.
// TODO: there is also a lockDateLocal and a dateLocal function in this module. We probably need to merge these things.
exports.shortDateUtah = d => {
	if (! d) return '';
	var x = coerceDate(d);
	if (! x) return '';
	var m = moment.tz(x, 'America/Denver');
	return m.format("MM/DD/YYYY");
}

exports.ymdDashes = d => {
	if (! d) return '';
	var x = moment(d);
	return x.format("YYYY-MM-DD");
}

exports.amerDate = d => {
	if (! d) return '';
	var x = moment(d);
	return x.format("MM/DD/YYYY");
}

exports.amerDateYY = d => {
	if (! d) return '';
	var x = moment(d);
	return x.format("MM/DD/YY");
}

exports.centierDate = d => {
	if (! d) return '';
	var x = moment(d);
	return x.format("YYYYMMDD");
}

exports.medDate = d => {
	if (! d) return '';
	var x = moment(d);
	return x.format("MMM D, YYYY");
}

exports.dateAndTime = d => {
	if (! d) return '';
	var x = moment(d);
	return x.format("YYYY-MM-DD HH:mm:ss");
}

exports.twelveHourDateAndTime = d => {
	if (! d) return '';
	var x = moment(d);
	return x.format("YYYY-MM-DD hh:mm A");
}

exports.hedgeMonth = (d) => {
	var myd = moment(coerceDate(d));
	if (myd.date() > 15) return myd.add(1, 'month').format('YYYY-MM');
	else return myd.format('YYYY-MM');
}

exports.yearMonth = (d) => {
	var myd = moment(coerceDate(d));
	return myd.format('MMM YYYY');
}


exports.localDayToDate = stamp => {
	var myMoment = moment.tz(stamp, "YYYY-MM-DD", "America/Denver");
	return myMoment.toDate();
}

exports.lockDateLocal = x => {
	return moment(x).tz("America/Denver").format('M/D/YYYY');
}

exports.dateLocal = x => {
	return moment(x).tz("America/Denver").format('YYYY-MM-DD');
}

exports.fmtMinNumber = min => {

	var digits = String(min || '').replace(/\D/g, '');

	if (digits === '') return '';

	if (digits.length === 18) {
		return(`${digits.substr(0,7)}-${digits.substr(7,10)}-${digits.substr(17)}`);
	}
	else if (digits.length > 7) {
		return(`${digits.substr(0,7)}-${digits.substr(7)}`);
	}

	return min || '';

}

exports.fmtMinNumberDigitOnly = min => {

	let value = String(min || '').replace(/\D/g, '');
	let newVal = `="${value}"`
	return newVal
}

exports.stripNonDigits = x => {

	var digits = String(x || '').replace(/\D/g, '');
	return digits;

}

exports.stripNonAlphabet = x => {

	var string = String(x || '').replace(/[^\ a-zA-Z]+/g, '');
	return string
}

exports.stripSpaces = x => {

	var result = String(x || '').split(' ').join('')
	return result;

}


exports.duration = x => {

	var units = 'sec';

	if (x > (3600 * 24)) {
		x = x / (3600 * 24);
		units = 'days';
	}

	else if (x > 3600) {
		x = x / 3600;
		units = 'hrs';
	}

	else if (x > 60) {
		x = x / 60;
		units = 'min';
	}

	x = numeral(x).format('0,0.0');

	return `${x} ${units}`;


}

exports.phoneDashes = x => {

	var baseNum = String(x || '').replace(/\D/g, '');
				baseNum = baseNum.replace(/^(\d{3})/, '$1-');
				baseNum = baseNum.replace(/-(\d{3})/, '-$1-');
				baseNum = baseNum.replace(/(\d)-(\d{4}).*/, '$1-$2');
				return baseNum;
}

exports.ssnDashes = x => {

	var baseNum = String(x || '').replace(/\D/g, '');
				baseNum = baseNum.replace(/^(\d{3})/, '$1-');
				baseNum = baseNum.replace(/-(\d{2})/, '-$1-');
				baseNum = baseNum.replace(/(\d)-(\d{4}).*/, '$1-$2');
				return baseNum;

}

exports.padNum = x => {
	if (! x) return '';
	var n = x.toString();
	if (n.length === 1) {
		n = "0" + n;
	}
	return n;
}

exports.limitFiveLength = x => {
	if (! x) return '';
	var n = x.substring(0, 5)
	return n
}

exports.noZero = x => {
	if (! x) return '';
	return x;
}

exports.blankNull = x => {
	if (!x) {
	return '<NULL>'
	} else return x
}

exports.blankIsAvailable = x => {
	if (!x) {
	return 'Is Available - Regular'
	} else return x
}

exports.percentThreeDecNull = n => {
	if (! n) return '<NULL>';
	var x = coerceFloat(n);
	return numeral(x).format('0.000');
}

exports.twoDecNoCommaNull = n => {
	if (! n) return '<NULL>';
	var x = coerceFloat(n);
	return numeral(x).format('0.00');
}

exports.validSsn = x => {
	if (! x) return '';
	else if (x.match(/^0{3}-?0{2}-?0{4}$/)) return '';
	else if (x.match(/^\d{3}-?\d{2}-?\d{4}$/)) {
		var baseNum = String(x || '').replace(/\D/g, '');
				baseNum = baseNum.replace(/^(\d{3})/, '$1-');
				baseNum = baseNum.replace(/-(\d{2})/, '-$1-');
				baseNum = baseNum.replace(/(\d)-(\d{4}).*/, '$1-$2');
				return baseNum;
	}
	else return '';
}

exports.amerDateNull = d => {
	if (! d) return '<NULL>';
	var x = moment(d);
	return x.format("MM/DD/YYYY");
}

exports.threeDecNull = n => {
	if (! n) return '<NULL>';
	var x = coerceFloat(n);
	return numeral(x).format('0,0.000');
}

exports.oneDecNull = n => {
	if (! n) return '<NULL>';
	var x = coerceFloat(n);
	return numeral(x).format('0,0.0');
}

exports.ssnDashesNull = x => {
	if (! x) return '<NULL>';
	var baseNum = String(x || '').replace(/\D/g, '');
				baseNum = baseNum.replace(/^(\d{3})/, '$1-');
				baseNum = baseNum.replace(/-(\d{2})/, '-$1-');
				baseNum = baseNum.replace(/(\d)-(\d{4}).*/, '$1-$2');
				return baseNum;

}

exports.phoneDashesNull = x => {
	if (! x) return '<NULL>';
	var baseNum = String(x || '').replace(/\D/g, '');
				baseNum = baseNum.replace(/^(\d{3})/, '$1-');
				baseNum = baseNum.replace(/-(\d{3})/, '-$1-');
				baseNum = baseNum.replace(/(\d)-(\d{4}).*/, '$1-$2');
				return baseNum;
}

exports.stripDashes = x => {
	if (! x ) return;
	var baseNum = String(x || '').replace(/\-/g, '');
		return baseNum;
}

exports.shortZipChop = x => {

	if (! x ) return;
	let zip = x.substring(0, 5)
	return zip
}

var dataUnits = ['B', 'KB', 'MB', 'GB', 'TB', '!'];

exports.dataSize = x => {

	var units = 0;
	while (x > 1024) {
		units += 1;
		x = x / 1024;
	}

	x = numeral(x).format('0,0.0');
	return `${x}${dataUnits[units]}`;

}

var moneyUnits = ['', 'K', 'M', 'B', 'T'];

exports.moneySize = x => {

	if (! x) return;
	x = Number(x);

	var units = 0;
	while (x > 1000) {
		units += 1;
		x = x / 1000;
	}

	x = numeral(x).format('0,0.0');
	return `$${x}${moneyUnits[units]}`;

}

exports.lastFourOfSsn = x => {
	if (!x) return '';
	var baseNum = String(x || '').replace(/\D/g, '');
	return baseNum.substring(baseNum.length - 4);
}

